// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useSnackbar } from 'notistack';
import React from 'react';
import { Box, Card, Switch, Typography } from '@mui/material';
import { useLocalStorage } from '../../contexts/LocalStorageContext';

export const DarkThemeToggle: React.FC = () => {
  const { localStorageState, setLocalStorageState } = useLocalStorage();
  const { enqueueSnackbar } = useSnackbar();

  const onToggle = () => {
    setLocalStorageState('isDark', `${!localStorageState?.isDark}`);
    enqueueSnackbar(`Dark mode ${!localStorageState?.isDark ? 'enabled' : 'disabled'}`);
  };
  const { isDark } = localStorageState;
  return (
    <Card
      sx={{ mb: 1, width: '50%', p: 1, display: 'flex', alignItems: 'center' }}
      variant="outlined"
    >
      <Box>
        <Typography fontWeight="bold">Dark mode</Typography>
        <Typography variant="body2">Toggle on for dark mode.</Typography>
      </Box>
      <Switch sx={{ ml: 'auto' }} checked={isDark} onChange={onToggle} />
    </Card>
  );
};
